import { integerPattern } from 'js/utilities/validation';

export const chequeRunActionsValidationRules = {
  chequeNumber: integerPattern,
};

export const chequeRunActionsRequiredKeys = Object.keys(
  chequeRunActionsValidationRules
);
